<template>
	<view>
		<view class="top-container">
			<view class="top-tabbar">
				 <view class="cu-bar search" style="width: 100%;">
				 	<view class="search-form round">
				 		<text class="cuIcon-search"></text>
				 		<input type="text" v-model="search" placeholder="请输入店员姓名/手机号" confirm-type="search" @confirm="searchConfirm"></input>
				 	</view>
				 </view>
			</view>
		</view>

		<!--列表-->
		<scroll-view scroll-y="true" class="scroll-Y" :style="'height:' + scrollviewHigh + 'px;'" lower-threshold="50"
		 @scrolltolower="scrolltolowerFunc">
			<view class="p-0-30 bg-white">
				<view class="border-b p-20-0" v-for="(item,index) in tableData" :key="index">
					<view class="d-b-c">
						<view class="team-team-photo">
							<image :src="item.user.avatarUrl" mode="aspectFill"></image>
						</view>
						<view class="flex-1 ml20 f24" :style="isSelect==1?'flex: 0.9;':''">
							<view class="d-b-c">
								<text class="f28 gray3">{{ item.user.nickName || '未绑定会员'}}</text>
								<text class="gray9">{{ item.create_time }}</text>
							</view>
							<view class="d-b-c">
								<text class="gray9">姓名：<text class="black">{{ item.real_name }}</text></text>
								<text class="gray9">手机号：<text class="black">{{ item.mobile }}</text></text>
							</view>
							<block v-if="isSelect==0">
								<view class="d-b-c">
									<text class="gray9">累计金额<text class="red">￥{{ item.total_money }}</text></text>
									<text class="gray9">已提现金额<text class="red">￥{{ item.cash_money }}</text></text>
								</view>
								<view class="d-b-c">
									<text class="gray9">冻结金额<text class="red">￥{{ item.freeze_money }}</text></text>
									<text class="gray9">可提现金额<text class="red">￥{{ item.money }}</text></text>
								</view>
							</block>
							
						</view>
						<view v-if="isSelect==1">
							<button class="send_btn btn-blue" @click="jumpOrder(item)">选择</button>
						</view>
					</view>
				</view>
				<!-- 没有记录 -->
				<view class="d-c-c p30" v-if="tableData.length==0 && !loading">
					<text class="iconfont icon-wushuju"></text>
					<text class="cont">亲，暂无相关记录哦</text>
				</view>
				<uni-load-more v-else :loadingType="loadingType"></uni-load-more>
			</view>
		</scroll-view>

	</view>
</template>

<script>
	import uniLoadMore from "@/components/uni-load-more.vue";
	export default {
		components: {
			uniLoadMore
		},
		data() {
			return {
				/*手机高度*/
				phoneHeight: 0,
				/*可滚动视图区域高度*/
				scrollviewHigh: 0,
				/*状态选中*/
				state_active: 0,
				/*数据列表*/
				tableData: [],
				setting: [],
				teamTotal: 0,
				page: 1,
				no_more: false,
				tabList: [],
				list_rows: 15,
				loading: true,
				search:'',
				isSelect:0
			}
		},
		computed: {
			/*加载中状态*/
			loadingType() {
				if (this.loading) {
					return 1;
				} else {
					if (this.tableData.length != 0 && this.no_more) {
						return 2;
					} else {
						return 0;
					}
				}
			}
		},
		mounted() {
			/*初始化*/
			this.init();
			/*获取数据*/
			this.getData();
		},
		onLoad(e) {
			if(e){
				this.isSelect=e.isSelect?1:0;
			}
		},
		methods: {
			searchConfirm(){
				let self = this;
				self.tableData = [];
				self.page = 1;
				self.getData();
			},
			/*初始化*/
			init() {
				let self = this;
				uni.getSystemInfo({
					success(res) {
						self.phoneHeight = res.windowHeight;
						// 计算组件的高度
						let view = uni.createSelectorQuery().select('.top-container');
						view.boundingClientRect(data => {
							let h = self.phoneHeight - data.height;
							self.scrollviewHigh = h;
						}).exec();
					}
				});
			},
			
			/*获取数据*/
			getData() {
				let self = this;
				self.loading = true;
				self._get('store.delivery/teamlists', {
					search: self.search,
					page: self.page || 1,
					list_rows: self.list_rows,
				}, function(res) {
					self.loading = false;
					//self.teamTotal = res.data.team.first_num;
					let data = res.data;
					self.tableData = self.tableData.concat(data.list.data);
					self.last_page = data.list.last_page;
					if (self.last_page <= 1) {
						self.no_more = true;
					}
				},null,function(){
					self.loading = false;
				});
			},

			/*切换类别*/
			stateFunc(e) {
				let self = this;
				if(e!=self.state_active){
					self.tableData = [];
					self.page = 1;
					self.state_active = e;
					self.getData();
				}
			},

			/*可滚动视图区域到底触发*/
			scrolltolowerFunc() {
				let self = this;
				if (self.no_more) {
					return;
				}
				self.page++;
				if (self.page <= self.last_page) {
					self.getData();
				} else {
					self.no_more = true;
				}
			},
			jumpOrder(item){
				let pages = getCurrentPages();  //获取所有页面栈实例列表
				let nowPage = pages[ pages.length - 1];  //当前页页面实例
				let prevPage = pages[ pages.length - 2 ];  //上一页页面实例
				prevPage.$vm.selectClerk = item;   //修改上一页data里面的searchVal参数值为222
				uni.navigateBack({  //uni.navigateTo跳转的返回，默认1为返回上一级
					delta: 1
				});
			}
		}
	}
</script>

<style>
	@import '/pages2/common/main.css';
	@import '/pages2/common/icon.css';
	.arrows{
		display: inline-block;
	}
	.arrows .icon{
		font-size: 20rpx;
	}
	.arrows .arrow{
		margin:0;
		padding:0;
		height: 20rpx;
		
	}
	.arrows .active .iconfont{
		color:#E2231A;
	}
	.bg-eee{
		background: #eee;
	}
	
	.top-container .total {
		height: 80rpx;
	}

	.team-team-photo,
	.team-team-photo image {
		width: 80rpx;
		height: 80rpx;
		border-radius: 50%;
	}
</style>
